import { useSelector } from 'react-redux'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { mapTableOfOthers } from '../constants'
import {
  selectAssociateCompanyData,
  selectAssociateCompanyIds,
} from '../store/slice'
import { NameCell } from './NameCell'
import PropTypes from 'prop-types'

export const AssociateCompanyTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectAssociateCompanyIds)

  return (
    <Table
      autoHeightMax={isDynamicReport ? undefined : 200}
      noDataText="companyAnalysis.ownershipAndGroup.ASSOCIATE_COMPANIES_NO_DATA"
      ids={ids}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectAssociateCompanyData}
      schema={Object.values(mapTableOfOthers).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          parentThStyle: isDynamicReport ? {} : item.parentThStyle,
          thStyle: item.thStyle,
          render: (val, { rowId, locale }) => {
            switch (item.key) {
              case mapTableOfOthers.organizationName.key:
                return (
                  <NameCell
                    item={item}
                    rowId={rowId}
                    val={val}
                    isDynamicReport={isDynamicReport}
                  />
                )

              case mapTableOfOthers.address.key:
                return isDynamicReport ? (
                  item.format(val)
                ) : (
                  <TextEllipsisStaticLine
                    lineClamp={2}
                    text={item.format(val)}
                  />
                )

              case mapTableOfOthers.percentage.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}

AssociateCompanyTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
